import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Row, Col, Card, ListGroup, Accordion } from 'react-bootstrap';
import { isValid, startOfDay, isToday, format as formatDate } from 'date-fns';
import { GetJson } from '@awp/helpers/fetchReact';
import { isValueEmpty, toStringOrEmpty, getUtcToLocal } from '@awp/helpers/utilsReact';
import Select from 'react-select';
import CurrentCondition from '@awp/components/WeatherForecast/CurrentCondition';
import CardHeaderToggle from '@components/Common/Accordion/CardHeaderToggle';
import ForecastTimeDays from '@awp/components/WeatherForecast/ForecastTimeDays';
import AwpSpinner from '@components/Common/AwpSpinner';
import { STATE_STATUS, EnabledFeature } from '@awp/constants';

import {
  setIssuedBy,
  setWeatherForecastId,
  setWeatherForecasts,
  setTextDescription,
  fetchWeatherForecastText,
  fetchWeatherForecasts,
  fetchWeatherForecast,
  selectIssuedBy,
  selectWeatherForecast,
  selectWeatherForecasts,
  selectWeatherForecastId,
  selectTextDescription,
  selectStatus,
  setStartDate,
  setEndDate,
  setDataRange,
  setWeatherStation,
} from '@stores/dataVisualizationSlice';
import { configStartDate } from '@awp/helpers/Utils';
import ForecastContainer from '@components/WeatherForecast/ForecastContainer';
import WeatherForecastLegends from '@components/WeatherForecast/WeatherForecastLegends';

export const resetForecast = (dispatch) => {
  dispatch(setTextDescription({}));
  dispatch(setWeatherForecastId(''));
  dispatch(setWeatherForecasts([]));
  dispatch(setIssuedBy('-1'));
};

const selectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    borderColor: '#adb5bd',
    color: '#494949',
    fontSize: '1rem',
  }),
  input: (styles) => ({ ...styles }),
  placeholder: (styles) => ({ ...styles, color: '#494949' }),
  dropdownIndicator: (styles) => ({ ...styles, color: '#797979', '&:hover': { color: '#494949' } }),
};

function ForecastFilter({ weatherStation, isMultiStation, stationSelections, dataRange }) {
  const dispatch = useDispatch();
  const forecastIssuedByDefaultOption = { value: '-1', label: 'Please select' };
  const forecastIssuedByOptions = [forecastIssuedByDefaultOption, { value: 'Weathernet', label: 'Weathernet' }];
  const allWeatherForecasts = useSelector(selectWeatherForecasts);
  const forecastIssuedBy = useSelector(selectIssuedBy);
  const selectedWeatherForecastId = useSelector(selectWeatherForecastId);
  const textDescription = useSelector(selectTextDescription);
  const selectedStatus = useSelector(selectStatus);

  useEffect(() => {
    if (!weatherStation || weatherStation.Id == null || Number.isNaN(weatherStation.Id)) return;
    if (isValueEmpty(forecastIssuedBy) || forecastIssuedBy === '-1') return;

    if (isMultiStation) {
      dispatch(
        fetchWeatherForecasts({
          weatherStationId: weatherStation.Id,
          endDate: dataRange.endDate,
          startDate: configStartDate(dataRange.endDate, dataRange.displayRange),
        }),
      );
    } else {
      dispatch(fetchWeatherForecasts());
    }

    dispatch(fetchWeatherForecastText());
    dispatch(fetchWeatherForecast({ isMultiStation: false, weatherStationId: weatherStation?.Id }));
  }, [weatherStation, forecastIssuedBy, selectedWeatherForecastId]);

  const getSelectedWeatherForecastOption = () => {
    if (isValueEmpty(selectedWeatherForecastId || !allWeatherForecasts || allWeatherForecasts.length === 0))
      return { value: null, label: 'Select issued time' };
    let selectedOpt = allWeatherForecasts.find((f) => f.Id == selectedWeatherForecastId);
    if (!selectedOpt || selectedOpt.length === 0) return { value: null, label: 'Select issued time' };
    return { value: selectedOpt.Id, label: getUtcToLocal(selectedOpt.ForecastIssueTimestamp) };
  };

  const getIssuedByOption = () => {
    if (
      (!isValueEmpty(forecastIssuedBy) && forecastIssuedBy === '-1') ||
      !forecastIssuedByOptions ||
      forecastIssuedByOptions.length === 0
    )
      return forecastIssuedByDefaultOption;
    let selectedOpt = forecastIssuedByOptions.find((f) => f.value == forecastIssuedBy);
    if (!selectedOpt || selectedOpt.length === 0) return forecastIssuedByDefaultOption;
    return selectedOpt;
  };

  const checkForecast = () => {
    if (!isValueEmpty(forecastIssuedBy) && forecastIssuedBy === '-1') return true;
    return !isValueEmpty(forecastIssuedBy) && allWeatherForecasts && allWeatherForecasts.length > 0;
  };

  const ResetForecast = () => {
    dispatch(setTextDescription({}));
    dispatch(setWeatherForecastId(''));
    dispatch(setWeatherForecasts([]));
  };

  const handleIssuedByChange = (e) => {
    dispatch(setIssuedBy(e.value));
    if (e.value === '-1') ResetForecast();
  };

  const handleIssuedTimeChange = (e) => {
    dispatch(setWeatherForecastId(e.value));
  };

  const caroselStationForward = () => {
    resetForecast(dispatch);
    stationSelections.moveWXForward();
  };

  const caroselStationBackward = () => {
    resetForecast(dispatch);
    stationSelections.moveWXBackward();
  };
  const isForecast = () => {
    return true;
    // return (
    //   status &&
    //   status.weatherForecasts !== STATE_STATUS.LOADING &&
    //   status.weatherForecast !== STATE_STATUS.LOADING &&
    //   forecastId > 0 &&
    //   presetId > 0 &&
    //   allWeatherForecasts &&
    //   allWeatherForecasts.length > 0
    // );
  };
  return (
    <>
      {weatherStation && (
        <Accordion defaultActiveKey="1">
          <Card border="light" className="page-card">
            <CardHeaderToggle as="h3" eventKey="0" title={'Weather Station Information'} />
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Row>
                  {isMultiStation ? (
                    <Button onClick={caroselStationBackward} className="carousel-button" aria-label="left-scroll">
                      <i className="bi bi-caret-left-fill" style={{ width: '1rem' }} />
                    </Button>
                  ) : null}
                  <Col md={2}>
                    <Card style={{ border: '0px' }}>
                      <Card.Body>
                        <Card.Title as="h4">{weatherStation.Name}</Card.Title>
                        {EnabledFeature.WeatherForecastMap && isForecast() && (
                          <>
                            <Card.Subtitle className="mb-2 text-muted small">
                              {'Elevation: ' + weatherStation.Elevation + 'm'}
                            </Card.Subtitle>
                            <Card.Link style={{ fontSize: '0.75rem' }} href="/Maps">
                              View on Map
                            </Card.Link>
                          </>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={3}>
                    <Card style={{ border: '0px' }}>
                      {isForecast() && (
                        <Card.Body>
                          <Card.Title as="h4">{'Pavement Condition'}</Card.Title>
                          <WeatherForecastLegends type="conidtion" />
                        </Card.Body>
                      )}
                    </Card>
                  </Col>
                  <Col md={3}>
                    <Card style={{ border: '0px' }}>
                      {isForecast() && (
                        <Card.Body>
                          <Card.Title as="h4">{'Pavement Temperature'}</Card.Title>
                          <WeatherForecastLegends type="temperature" />
                        </Card.Body>
                      )}
                    </Card>
                  </Col>
                  <Col>
                    <Row>
                      <Col>
                        <Card style={{ border: '0rem' }}>
                          <Card.Body>
                            <Card.Title as="h4">Forecast</Card.Title>
                            <Row className="dataTables-validation-font">
                              <Col md={12} style={{ zIndex: 6, marginBottom: '0.75rem' }}>
                                <Form.Label as="h5">
                                  <b>Forecast Issued By</b>
                                </Form.Label>

                                {forecastIssuedBy && (
                                  <Select
                                    options={forecastIssuedByOptions}
                                    value={getIssuedByOption()}
                                    onChange={handleIssuedByChange}
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row className="dataTables-validation-font">
                              <Col md={12} style={{ zIndex: 2 }}>
                                <Form.Group controlId="v_issued_by_date_input_controlId">
                                  <Form.Label as="h5">
                                    <b>Issue Time &#38; Date</b>
                                  </Form.Label>
                                  <Select
                                    options={allWeatherForecasts.map((wf) => {
                                      return { value: wf.Id, label: getUtcToLocal(wf.ForecastIssueTimestamp) };
                                    })}
                                    value={getSelectedWeatherForecastOption()}
                                    placeholder={'Select issued time'}
                                    onChange={handleIssuedTimeChange}
                                    maxMenuHeight={200}
                                    isDisabled={forecastIssuedBy == '-1' || isValueEmpty(forecastIssuedBy)}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                  {isMultiStation ? (
                    <Button onClick={caroselStationForward} className="carousel-button" aria-label="right-scroll">
                      <i className="bi bi-caret-right-fill" style={{ width: '1rem' }} />
                    </Button>
                  ) : null}
                </Row>
                {selectedStatus &&
                  (selectedStatus.textDescription === STATE_STATUS.LOADING ||
                    selectedStatus.weatherForecasts === STATE_STATUS.LOADING ||
                    selectedStatus.weatherForecast === STATE_STATUS.LOADING) && <AwpSpinner />}
                {selectedStatus &&
                  selectedStatus.textDescription !== STATE_STATUS.LOADING &&
                  selectedStatus.weatherForecasts !== STATE_STATUS.LOADING &&
                  selectedStatus.weatherForecast !== STATE_STATUS.LOADING && (
                    <>
                      {selectedWeatherForecastId > 0 && weatherStation && weatherStation.Id > 0 && (
                        <ForecastContainer
                          key={selectedWeatherForecastId}
                          isSingleStation={true}
                          singleStationId={weatherStation.Id}
                          singleHourlyEnd={textDescription?.HourlyEnd}
                        />
                      )}
                      <ForecastTimeDays hasForecast={checkForecast()} />
                    </>
                  )}
                <Row style={{ paddingLeft: '0.625rem' }}>
                  <Col md={4} style={{ fontSize: '80%' }}>
                    {!isValueEmpty(textDescription) ? 'Confidence: ' + toStringOrEmpty(textDescription.Confidence) : ''}
                  </Col>
                  <Col md={4} style={{ fontSize: '80%' }}>
                    {!isValueEmpty(textDescription) ? 'Forecaster: ' + toStringOrEmpty(textDescription.Forecaster) : ''}
                  </Col>
                </Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}
    </>
  );
}

export default ForecastFilter;
